// Vite's dev proxy (vite.config.ts) forwards /api and /health to the Go
// server on :8000, and the production binary serves the built SPA and the
// API from the same origin — so a relative base works in both cases.
export const API_BASE_URL = '/api';
